import gql from 'graphql-tag';

export const webpageTypeFacetFragment = gql`
  fragment webpageTypeFacetFragment on WebpageTypeFacet {
    dokkioClass
    count
    webpageType
  }
`;
export default webpageTypeFacetFragment;
